import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import typography from '@material-ui/core/Typography';
import style from '../../styles';
import drawerMenu from '../utils/drawerMenu';


const styles = {
  divLogo: {
    width: '100%',
    color: 'red',
  },
  logoLife: {
    width: 90,
  },
  logo: {
    cursor: 'pointer',
    fontSize: 22,
    color: typography.textFullWhite,
    lineHeight: 16,
    fontWeight: typography.fontWeightLight,
    paddingLeft: 40,
    height: 56,
  },
  avatar: {
    div: {
      backgroundImage: `url(${style.bgProfile})`,
      height: 80,
      width: 190,
    },
    info: {
      width: 190,
    },
    icon: {
      display: 'block',
      marginLeft: 40,
      boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.2)',
    },
    span: {
      textAlign: 'center',
      display: 'block',
      color: '#000',
      fontWeight: 300,
      fontFamily: 'Poppins',
      fontSize: 14,
    },
  },
  nav: {
    marginLeft: 10,
  },
};


const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

class LeftDrawer extends Component {

  static propTypes = {
    navDrawerOpen: PropTypes.bool,
    menus: PropTypes.any,
    user: PropTypes.any,
    width: PropTypes.number,
    themeConfig: PropTypes.any.isRequired,
  };

  static defaultProps = {
    navDrawerOpen: false,
    width: 270,
  };

  constructor(props) {

    super(props);

    this.state = {
      menuStatus: {},
      ShowDivRelatorioFaturamento: false,
      open: true,
      activeMenu: '',
    };

    this.onClickMenu = this.onClickMenu.bind(this);

  }

  setMenuSelected(menu) {

    let menuStatus = {};
    menuStatus = this.state.menuStatus;

    Object.keys(menuStatus).forEach(key => (menuStatus[key].open = false));

    const setOpen = (id) => {

      if (menuStatus && menuStatus[id]) {

        menuStatus[id].open = true;
        if (menuStatus[id].parentId) setOpen(menuStatus[id].parentId);

      }

    };

    setOpen(menu.id);

    this.setState({ menuStatus });
    this.forceUpdate();

  }

  onClickMenu(event, activeMenu) {


    if (this.state.activeMenu === activeMenu) this.setState({
      activeMenu: '',
    });
    else this.setState({
      activeMenu,
    });

    localStorage.setItem('activeMenu', activeMenu);

  }

  updateMenuState(menus) {

    const menuStatus = {};

    const runTree = (menu, parentId) => {

      menuStatus[menu.id] = {
        id: menu.id,
        open: false,
        parentId,
        route: menu.reactModule,
        visible: menu.visible,
      };

      if (menu.children && menu.children.length) menu.children.map(children => (runTree(children, menu.id)));


    };

    menus.map(menu => (runTree(menu, null)));

    this.setState({ menuStatus });

    const pathName = window.location.pathname.split('/');

    const currentItemOpened = _.filter(menuStatus, (menu) => {

      let has = false;

      if (pathName.length === 2 && (menu.route.indexOf(pathName[0]) > -1 || menu.route.indexOf(pathName[1]) > -1)) has = true;
      else if (pathName.length === 3 && menu.route.indexOf(pathName[2]) > -1) has = true;
      else if (pathName.length >= 4 && menu.route.indexOf(pathName[2]) > -1 && (pathName[3] === 'add' || pathName[3] === 'edit')) has = true;


      return has;

    });

    setTimeout(() => {

      if (currentItemOpened) currentItemOpened.map(this.setMenuSelected.bind(this));


    }, 500);

  }

  componentWillReceiveProps(nextProps) {

    if (this.props.menus.length !== nextProps.menus.length) this.updateMenuState(nextProps.menus);

  }


  componentDidMount() {

    if (this.props.menus.length) this.updateMenuState(this.props.menus);
    const activeMenu = localStorage.getItem('activeMenu');
    this.onClickMenu('', activeMenu);

  }

  state = {
    anchorConfig: null,
    anchorNota: null,
  };

  handleClickConfig = event => this.setState({ anchorConfig: event.currentTarget });

  handleCloseConfig = () => this.setState({ anchorConfig: null });

  handleClickNota = event => this.setState({ anchorNota: event.currentTarget });

  handleCloseNota = () => this.setState({ anchorNota: null });

  handleMenuChange(menu) {

  }

  render() {

    const {
      navDrawerOpen, user, menus, width, classes, themeConfig,
    } = this.props;
    const { menuStatus } = this.state;

    const { anchorNota, anchorConfig } = this.state;
    const openConfig = Boolean(anchorConfig);
    const openNota = Boolean(anchorNota);

    return (

      <Drawer
        variant="persistent"
        open={navDrawerOpen}
        anchor="left"
      >

        <AppBar title={I18n.t('application.title')} iconElementLeft={<div />} />


        <div style={styles.avatar.div}>
          { user
            && (
              <Avatar
                size={100}
                style={styles.avatar.icon}
              />
            )}
        </div>


        <div style={styles.avatar.info}>
          { user && user.context(
            <div>
              <p style={styles.avatar.span}>
              Bem vindo,
                {' '}
                {user.Name}
!
              </p>
              <p style={styles.avatar.span}>
              Empresa:
                {' '}
                {user.context.name}
              </p>
            </div>,
          )
          }
        </div>

        <List
          className="menu"
          component="nav"
          style={styles.nav}
          subheader={
            <ListSubheader component="div" />}
        >

          {drawerMenu.map(item => (

            <div>
              { item.route
              && (
                <li>

                  <NavLink
                    to={item.route}
                    activeClassName="activeLink"
                    onClick={event => this.onClickMenu(event, item.name)}
                  >
                    {I18n.t(`menu.${item.name}`)}
                  </NavLink>
                </li>
              )
              }

              { item.children
              && (
                <li className="animatedMenu">
                  <a
                    onClick={event => this.onClickMenu(event, item.name)}
                    role="button"
                    tabIndex={-42}
                    className={this.state.activeMenu === item.name ? 'activeLink show' : 'hide'}
                  >
                    {' '}
                    {I18n.t(`menu.${item.name}`)}

                  </a>
                  {this.state.activeMenu === item.name
                && (
                  <ul className="sub-menu">
                    { item.children.map(children => (
                      <li>
                        <NavLink to={children.route} className="link" activeClassName="activeLink">
                          {I18n.t(`menu.${children.name}`)}
                        </NavLink>
                      </li>
                    ))}

                  </ul>
                )
                  }
                </li>
              )

              }


            </div>


          ))}
        </List>

      </Drawer>


    );

  }

}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeftDrawer),
);



// WEBPACK FOOTER //
// ./src/app/drawer/Drawer.js